import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { CropField, GroupedCropFields } from 'src/app/shared/models';

export interface OverviewDialogModel extends AbstractDialogData {
  groupedCropFields: GroupedCropFields;
  cropFields: CropField[];
}

@Component({
  selector: 'app-overview-dialog',
  templateUrl: './overview-dialog.component.html',
  standalone: false,
})
export class OverviewDialogComponent extends AbstractDialog {
  private readonly locale = inject(LocaleService);
  protected decimalPipe = inject(DecimalPipe);
  data = inject<OverviewDialogModel>(MAT_DIALOG_DATA);
  protected mdDialogRef =
    inject<MatDialogRef<OverviewDialogComponent, AbstractDialogResultData<never>>>(MatDialogRef);

  constructor() {
    super() /* istanbul ignore next */;
    const data = this.data;

    data.title = this.locale.translate('overview');
  }
}
